export const PermissionEnum = Object.freeze({
  CREATE_PAYMENT_METHODS: "CREATE_PAYMENT_METHODS",
  READ_PAYMENT_METHODS: "READ_PAYMENT_METHODS",
  UPDATE_PAYMENT_METHODS: "UPDATE_PAYMENT_METHODS",
  DELETE_PAYMENT_METHODS: "DELETE_PAYMENT_METHODS",

  CREATE_CUSTOMERS: "CREATE_CUSTOMERS",
  READ_CUSTOMERS: "READ_CUSTOMERS",
  UPDATE_CUSTOMERS: "UPDATE_CUSTOMERS",
  DELETE_CUSTOMERS: "DELETE_CUSTOMERS",

  CREATE_OUTLETS: "CREATE_OUTLETS",
  READ_OUTLETS: "READ_OUTLETS",
  UPDATE_OUTLETS: "UPDATE_OUTLETS",
  DELETE_OUTLETS: "DELETE_OUTLETS",

  CREATE_COMPANIES: "CREATE_COMPANIES",
  READ_COMPANIES: "READ_COMPANIES",
  UPDATE_COMPANIES: "UPDATE_COMPANIES",
  DELETE_COMPANIES: "DELETE_COMPANIES",

  CREATE_PRODUCT_CATEGORIES: "CREATE_PRODUCT_CATEGORIES",
  READ_PRODUCT_CATEGORIES: "READ_PRODUCT_CATEGORIES",
  UPDATE_PRODUCT_CATEGORIES: "UPDATE_PRODUCT_CATEGORIES",
  DELETE_PRODUCT_CATEGORIES: "DELETE_PRODUCT_CATEGORIES",

  CREATE_PRODUCT_VARIANT_ATTRIBUTES: "CREATE_PRODUCT_VARIANT_ATTRIBUTES",
  READ_PRODUCT_VARIANT_ATTRIBUTES: "READ_PRODUCT_VARIANT_ATTRIBUTES",
  UPDATE_PRODUCT_VARIANT_ATTRIBUTES: "UPDATE_PRODUCT_VARIANT_ATTRIBUTES",
  DELETE_PRODUCT_VARIANT_ATTRIBUTES: "DELETE_PRODUCT_VARIANT_ATTRIBUTES",

  CREATE_PRODUCT_VARIANTS: "CREATE_PRODUCT_VARIANTS",
  READ_PRODUCT_VARIANTS: "READ_PRODUCT_VARIANTS",
  UPDATE_PRODUCT_VARIANTS: "UPDATE_PRODUCT_VARIANTS",
  DELETE_PRODUCT_VARIANTS: "DELETE_PRODUCT_VARIANTS",

  CREATE_PRODUCTS: "CREATE_PRODUCTS",
  READ_PRODUCTS: "READ_PRODUCTS",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  DELETE_PRODUCTS: "DELETE_PRODUCTS",

  READ_SALES_REQUESTS: "READ_SALES_REQUESTS",

  CREATE_SALES_ORDERS: "CREATE_SALES_ORDERS",
  READ_SALES_ORDERS: "READ_SALES_ORDERS",
  UPDATE_SALES_ORDERS: "UPDATE_SALES_ORDERS",
  VOID_SALES_ORDERS: "VOID_SALES_ORDERS",

  CREATE_DELIVERY_ORDERS: "CREATE_DELIVERY_ORDERS",
  READ_DELIVERY_ORDERS: "READ_DELIVERY_ORDERS",
  UPDATE_DELIVERY_ORDERS: "UPDATE_DELIVERY_ORDERS",

  CREATE_SALES_INVOICES: "CREATE_SALES_INVOICES",
  READ_SALES_INVOICES: "READ_SALES_INVOICES",
  UPDATE_SALES_INVOICES: "UPDATE_SALES_INVOICES",

  CREATE_SALES_DOWN_PAYMENTS: "CREATE_SALES_DOWN_PAYMENTS",
  READ_SALES_DOWN_PAYMENTS: "READ_SALES_DOWN_PAYMENTS",
  UPDATE_SALES_DOWN_PAYMENTS: "UPDATE_SALES_DOWN_PAYMENTS",

  CREATE_SALES_PAYMENTS: "CREATE_SALES_PAYMENTS",
  READ_SALES_PAYMENTS: "READ_SALES_PAYMENTS",
  UPDATE_SALES_PAYMENTS: "UPDATE_SALES_PAYMENTS",

  CREATE_SALES_RETURNS: "CREATE_SALES_RETURNS",
  READ_SALES_RETURNS: "READ_SALES_RETURNS",
  UPDATE_SALES_RETURNS: "UPDATE_SALES_RETURNS",

  CREATE_CUSTOMER_CLAIMS: "CREATE_CUSTOMER_CLAIMS",
  READ_CUSTOMER_CLAIMS: "READ_CUSTOMER_CLAIMS",
  UPDATE_CUSTOMER_CLAIMS: "UPDATE_CUSTOMER_CLAIMS",

  CREATE_UNIT_OF_MEASUREMENTS: "CREATE_UNIT_OF_MEASUREMENTS",
  READ_UNIT_OF_MEASUREMENTS: "READ_UNIT_OF_MEASUREMENTS",
  UPDATE_UNIT_OF_MEASUREMENTS: "UPDATE_UNIT_OF_MEASUREMENTS",
  DELETE_UNIT_OF_MEASUREMENTS: "DELETE_UNIT_OF_MEASUREMENTS",

  CREATE_USERS: "CREATE_USERS",
  READ_USERS: "READ_USERS",
  UPDATE_USERS: "UPDATE_USERS",
  DELETE_USERS: "DELETE_USERS",

  READ_USER_OUTLET: "READ_USER_OUTLET",
  UPSERT_USER_OUTLET: "UPSERT_USER_OUTLET",

  CREATE_EXPENSE_CATEGORIES: "CREATE_EXPENSE_CATEGORIES",
  READ_EXPENSE_CATEGORIES: "READ_EXPENSE_CATEGORIES",
  UPDATE_EXPENSE_CATEGORIES: "UPDATE_EXPENSE_CATEGORIES",
  DELETE_EXPENSE_CATEGORIES: "DELETE_EXPENSE_CATEGORIES",

  CREATE_EXPENSES: "CREATE_EXPENSES",
  READ_EXPENSES: "READ_EXPENSES",

  CREATE_EXPENSE_ACCRUALS: "CREATE_EXPENSE_ACCRUALS",
  READ_EXPENSE_ACCRUALS: "READ_EXPENSE_ACCRUALS",
  UPDATE_EXPENSE_ACCRUALS: "UPDATE_EXPENSE_ACCRUALS",
  DELETE_EXPENSE_ACCRUALS: "DELETE_EXPENSE_ACCRUALS",

  CREATE_OTHER_PAYMENTS: "CREATE_OTHER_PAYMENTS",
  READ_OTHER_PAYMENTS: "READ_OTHER_PAYMENTS",
  UPDATE_OTHER_PAYMENTS: "UPDATE_OTHER_PAYMENTS",
  DELETE_OTHER_PAYMENTS: "DELETE_OTHER_PAYMENTS",

  READ_CASH_DRAWER_SHIFTS: "READ_CASH_DRAWER_SHIFTS",
  OPEN_CASH_DRAWER_SHIFTS: "OPEN_CASH_DRAWER_SHIFTS",
  CLOSE_CASH_DRAWER_SHIFTS: "CLOSE_CASH_DRAWER_SHIFTS",
  ACKNOWLEDGE_CASH_DRAWER_SHIFTS: "ACKNOWLEDGE_CASH_DRAWER_SHIFTS",

  CREATE_SUPPLIERS: "CREATE_SUPPLIERS",
  READ_SUPPLIERS: "READ_SUPPLIERS",
  UPDATE_SUPPLIERS: "UPDATE_SUPPLIERS",
  DELETE_SUPPLIERS: "DELETE_SUPPLIERS",

  CREATE_SUPPLIER_CATEGORIES: "CREATE_SUPPLIER_CATEGORIES",
  READ_SUPPLIER_CATEGORIES: "READ_SUPPLIER_CATEGORIES",
  UPDATE_SUPPLIER_CATEGORIES: "UPDATE_SUPPLIER_CATEGORIES",
  DELETE_SUPPLIER_CATEGORIES: "DELETE_SUPPLIER_CATEGORIES",

  CREATE_PAYMENT_TERMS: "CREATE_PAYMENT_TERMS",
  READ_PAYMENT_TERMS: "READ_PAYMENT_TERMS",
  UPDATE_PAYMENT_TERMS: "UPDATE_PAYMENT_TERMS",
  DELETE_PAYMENT_TERMS: "DELETE_PAYMENT_TERMS",

  CREATE_WAREHOUSES: "CREATE_WAREHOUSES",
  READ_WAREHOUSES: "READ_WAREHOUSES",
  UPDATE_WAREHOUSES: "UPDATE_WAREHOUSES",
  DELETE_WAREHOUSES: "DELETE_WAREHOUSES",

  CREATE_PURCHASE_ORDERS_STANDARD: "CREATE_PURCHASE_ORDERS_STANDARD",
  READ_PURCHASE_ORDERS_STANDARD: "READ_PURCHASE_ORDERS_STANDARD",
  UPDATE_PURCHASE_ORDERS_STANDARD: "UPDATE_PURCHASE_ORDERS_STANDARD",

  CREATE_PURCHASE_ORDERS_LAB: "CREATE_PURCHASE_ORDERS_LAB",
  READ_PURCHASE_ORDERS_LAB: "READ_PURCHASE_ORDERS_LAB",
  UPDATE_PURCHASE_ORDERS_LAB: "UPDATE_PURCHASE_ORDERS_LAB",

  CREATE_GOODS_RECEIPTS: "CREATE_GOODS_RECEIPTS",
  READ_GOODS_RECEIPTS: "READ_GOODS_RECEIPTS",
  UPDATE_GOODS_RECEIPTS: "UPDATE_GOODS_RECEIPTS",

  CREATE_PURCHASE_INVOICES: "CREATE_PURCHASE_INVOICES",
  READ_PURCHASE_INVOICES: "READ_PURCHASE_INVOICES",
  UPDATE_PURCHASE_INVOICES: "UPDATE_PURCHASE_INVOICES",

  CREATE_PURCHASE_PAYMENTS: "CREATE_PURCHASE_PAYMENTS",
  READ_PURCHASE_PAYMENTS: "READ_PURCHASE_PAYMENTS",
  UPDATE_PURCHASE_PAYMENTS: "UPDATE_PURCHASE_PAYMENTS",

  CREATE_PURCHASE_RETURNS: "CREATE_PURCHASE_RETURNS",
  READ_PURCHASE_RETURNS: "READ_PURCHASE_RETURNS",
  UPDATE_PURCHASE_RETURNS: "UPDATE_PURCHASE_RETURNS",

  CREATE_PURCHASE_DOWN_PAYMENTS: "CREATE_PURCHASE_DOWN_PAYMENTS",
  READ_PURCHASE_DOWN_PAYMENTS: "READ_PURCHASE_DOWN_PAYMENTS",
  UPDATE_PURCHASE_DOWN_PAYMENTS: "UPDATE_PURCHASE_DOWN_PAYMENTS",

  READ_SALES_ORDER_REPORT: "READ_SALES_ORDER_REPORT",
  READ_SALES_ORDER_PAYMENT_REPORT: "READ_SALES_ORDER_PAYMENT_REPORT",
  READ_EXPENSE_REPORT: "READ_EXPENSE_REPORT",
  READ_SALES_ORDER_PRODUCT_REPORT: "READ_SALES_ORDER_PRODUCT_REPORT",
  READ_COST_OF_GOODS_SOLD_REPORT: "READ_COST_OF_GOODS_SOLD_REPORT",
  READ_INVENTORY_VALUE_REPORT: "READ_INVENTORY_VALUE_REPORT",

  CREATE_ROLES: "CREATE_ROLES",
  READ_ROLES: "READ_ROLES",
  UPDATE_ROLES: "UPDATE_ROLES",
  DELETE_ROLES: "DELETE_ROLES",

  READ_PERMISSIONS: "READ_PERMISSIONS",

  UPDATE_PRODUCT_RETAIL_PRICE: "UPDATE_PRODUCT_RETAIL_PRICE",
  UPDATE_PRODUCT_DISTRIBUTOR_PRICE: "UPDATE_PRODUCT_DISTRIBUTOR_PRICE",

  CREATE_CHART_OF_ACCOUNTS: "CREATE_CHART_OF_ACCOUNTS",
  READ_CHART_OF_ACCOUNTS: "READ_CHART_OF_ACCOUNTS",
  UPDATE_CHART_OF_ACCOUNTS: "UPDATE_CHART_OF_ACCOUNTS",
  DELETE_CHART_OF_ACCOUNTS: "DELETE_CHART_OF_ACCOUNTS",

  CREATE_OUTLET_CHART_OF_ACCOUNTS: "CREATE_OUTLET_CHART_OF_ACCOUNTS",
  READ_OUTLET_CHART_OF_ACCOUNTS: "READ_OUTLET_CHART_OF_ACCOUNTS",
  UPDATE_OUTLET_CHART_OF_ACCOUNTS: "UPDATE_OUTLET_CHART_OF_ACCOUNTS",
  DELETE_OUTLET_CHART_OF_ACCOUNTS: "DELETE_OUTLET_CHART_OF_ACCOUNTS",

  CREATE_JOURNAL_VOUCHERS: "CREATE_JOURNAL_VOUCHERS",
  READ_JOURNAL_VOUCHERS: "READ_JOURNAL_VOUCHERS",
  UPDATE_JOURNAL_VOUCHERS: "UPDATE_JOURNAL_VOUCHERS",
  DELETE_JOURNAL_VOUCHERS: "DELETE_JOURNAL_VOUCHERS",

  CREATE_PROMOTIONS: "CREATE_PROMOTIONS",
  READ_PROMOTIONS: "READ_PROMOTIONS",
  UPDATE_PROMOTIONS: "UPDATE_PROMOTIONS",
  DELETE_PROMOTIONS: "DELETE_PROMOTIONS",

  UPDATE_ACCOUNTING_ACTION_CHART_OF_ACCOUNT:
    "UPDATE_ACCOUNTING_ACTION_CHART_OF_ACCOUNT",
  READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT:
    "READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT",
  UPDATE_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES:
    "UPDATE_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES",
  READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES:
    "READ_ACCOUNTING_ACTION_CHART_OF_ACCOUNT_PREFERENCES",

  CREATE_STOCK_ADJUSTMENTS: "CREATE_STOCK_ADJUSTMENTS",
  READ_STOCK_ADJUSTMENTS: "READ_STOCK_ADJUSTMENTS",
  UPDATE_STOCK_ADJUSTMENTS: "UPDATE_STOCK_ADJUSTMENTS",
  DELETE_STOCK_ADJUSTMENTS: "DELETE_STOCK_ADJUSTMENTS",
});
